import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AdminApp from "./AdminApp.jsx";
import AdminLoginPage from "./pages/AdminLoginPage.jsx";
import AdminUpdateBanner from "./components/AdminUpdateBanner.jsx";

function App() {
  return (
    <>
      <AdminUpdateBanner />
      <Routes>
        <Route path="/login" element={<AdminLoginPage />} />
        <Route path="/*" element={<AdminApp />} />
      </Routes>
    </>
  );
}

export default App;
